import { render } from "./ImportAnnotators.vue?vue&type=template&id=bc4f00a0&ts=true"
import script from "./ImportAnnotators.vue?vue&type=script&lang=ts"
export * from "./ImportAnnotators.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__